import { useEffect, useState } from 'react';

import I18nFactory from '../../kakapo-ui-services/factories/I18nFactory';
import ConfigService, {
	ITenantConfig,
} from '../../kakapo-ui-services/services/common/ConfigService';
import AppRoot from '../common/containers/AppRoot';
import FullPageLoadingContainer from '../pages/loading/FullPageLoadingContainer';

export default function ConfigGuard() {
	const [initialized, setInitialized] = useState<boolean>(false);
	const [error, setError] = useState<Error | null>(null);
	const [tenantConfig, setTenantConfig] = useState<ITenantConfig>();

	const initialize = async () => {
		try {
			const config = await ConfigService.fetchConfigForHost(
				window.location.host,
				process.env.NODE_ENV === 'development',
			);
			if (config !== undefined) {
				setTenantConfig(config);
			}
		} catch (e) {
			setError(e);
		}
	};

	useEffect(() => {
		initialize();
	}, []);

	useEffect(() => {
		if (tenantConfig === null || tenantConfig === undefined) {
			return;
		}

		(async () => {
			await I18nFactory.create(tenantConfig!);
			setInitialized(true);
		})();
	}, [tenantConfig]);

	if (error) {
		return <div className="page-content">{error!.message}</div>;
	}

	if (!initialized) {
		return <FullPageLoadingContainer />;
	}

	return <AppRoot />;
}
